import { wealthProApi } from "../../redux/api";

const clientSetAccessApiEndpoints = wealthProApi.enhanceEndpoints({
    // TODO addTagTypes: 
}).injectEndpoints({
    endpoints: (builder) => ({
        fetchClientSetAccess: builder.query({
            query: ({ clientSetId }) => `api/campaignmanagement/client-sets/${clientSetId}/access`,
            // TODO providesTags:
        }),
        addClientSetAccess: builder.mutation({
            query: ({ clientSetId, userId, ...body }) => ({
                url: `api/campaignmanagement/client-sets/${clientSetId}/access/${userId}`,
                method: "POST",
                body
            }),
            async onQueryStarted({ clientSetId, ...data }, { dispatch, queryFulfilled }) {
                try {
                    const addResult = dispatch(wealthProApi.util.updateQueryData("fetchClientSetAccess", { clientSetId }, (draft) => [
                        ...draft,
                        data
                    ]));

                    try {
                        await queryFulfilled;
                    } catch (error) {
                        console.error("Error adding client set access:", error);
                        addResult.undo();
                    }
                } catch (error) {
                    console.error("Error updating cache after adding client set access:", error);
                }
            }
            // TODO invalidatesTags:
        }),
        patchClientSetAccess: builder.mutation({
            query: ({ clientSetId, userId, ...body }) => ({
                url: `api/campaignmanagement/client-sets/${clientSetId}/access/${userId}`,
                method: "PATCH",
                body
            }),
            async onQueryStarted({ clientSetId, userId, canRead, canWrite }, { dispatch, queryFulfilled }) {
                try {
                    const patchResult = dispatch(wealthProApi.util.updateQueryData("fetchClientSetAccess", { clientSetId }, (draft) => {
                        const index = draft.findIndex((item) => item.userId === userId);
                        if (index !== -1) {
                            if (canRead != null)
                                draft[index].canRead = canRead;
                            if (canWrite != null)
                                draft[index].canWrite = canWrite;

                            // Remove the item if both canRead and canWrite are false
                            if (draft[index].canRead === false && draft[index].canWrite === false) {
                                draft = draft.splice(index, 1);
                            }
                        }
                    }));

                    try {
                        await queryFulfilled;
                    } catch (error) {
                        console.error("Error updating client set access:", error);
                        patchResult.undo();
                    }
                } catch (error) {
                    console.error("Error updating cache after patching client set access:", error);
                }
            }
            // TODO invalidatesTags:
        }),
    })
})

export const {
    useFetchClientSetAccessQuery,
    useAddClientSetAccessMutation,
    usePatchClientSetAccessMutation
} = clientSetAccessApiEndpoints;